import { CoreDataSourceRegistrator, getCustomization } from "@multiweb/customization";

// Získání customizacni instance
const customizationInstance = getCustomization();

customizationInstance.core.init(new CoreDataSourceRegistrator());
